var exports = {
  "kL": "CompactVoiceCallView.module__container___cnZZYV",
  "gw": "CompactVoiceCallView.module__containerNoHeader___cnZZYV",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___cnZZYV",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___cnZZYV",
  "ap": "CompactVoiceCallView.module__containerFillHeight___cnZZYV",
  "tZ": "CompactVoiceCallView.module__contentArea___cnZZYV",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___cnZZYV",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___cnZZYV",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___cnZZYV",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___cnZZYV",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___cnZZYV",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___cnZZYV",
  "D9": "CompactVoiceCallView.module__layoutHost___cnZZYV",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___cnZZYV",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___cnZZYV",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___cnZZYV",
  "_t": "CompactVoiceCallView.module__controlBarSection___cnZZYV",
  "Vw": "CompactVoiceCallView.module__controlBarInner___cnZZYV",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___cnZZYV",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___cnZZYV",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___cnZZYV",
  "x8": "CompactVoiceCallView.module__heightTogglePill___cnZZYV",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___cnZZYV",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___cnZZYV",
  "Di": "CompactVoiceCallView.module__resizeHandle___cnZZYV",
  "YC": "CompactVoiceCallView.module__resizePill___cnZZYV",
  "$I": "CompactVoiceCallView.module__containerResizing___cnZZYV",
};

module.exports = exports;
